import { toast } from "react-toastify"

const initState = {
    isLoading: false,
    updatingReactions: false,
    error: null,
    apiData: {
        country: null,
        countryDoc: null,
        user: null,
        notifications: null,
        allUsers: {
            page: 1,
            currentUsers: null,
            lastUser: null,
            firstUser: null
        }
    }
}

const apiReducer = (state = initState, action) => {
    switch (action.type) {
        case 'API_REQUEST_START':
            return {
                ...state,
                isLoading: true
            }
        case 'START_UPDATING_REACTIONS':
            return {
                ...state,
                updatingReactions: true
            }
        case 'COUNTRY_DATA_SUCCESS':
            return {
                ...state,
                isLoading: false,
                error: null,
                apiData: {
                    ...state.apiData,
                    country: action.payload.country,
                    countryDoc: action.payload.countryDoc
                }
            }
        case 'COUNTRY_DATA_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'NEWS_DATA_SUCCESS':
            return {
                ...state,
                isLoading: false,
                error: null,
                apiData: { ...state.apiData, news: action.payload }
            }
        case 'NEWS_DATA_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'NEWS_STUDY_DATA_SUCCESS':
            return {
                ...state,
                isLoading: false,
                error: null,
                apiData: { ...state.apiData, newsStudyGame: action.payload }
            }
        case 'NEWS_STUDY_DATA_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'GET_USERS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                apiData: {
                    ...state.apiData,
                    allUsers: {
                        currentUsers: action.payload,
                        lastUser: action.lastUser,
                        firstUser: action.firstUser,
                        page: action.page
                    }
                }
            }
        case 'GET_USERS_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'GET_OWN_USER_SUCCESS':
            return {
                ...state,
                apiData: { ...state.apiData, user: null }
            }
        case 'GET_OWN_USER_ERROR':
            return {
                ...state,
                apiData: { ...state.apiData, user: null },
                error: action.error
            }
        case 'GET_USER_SUCCESS':
            return {
                ...state,
                isLoading: false,
                apiData: { ...state.apiData, user: action.payload }
            }
        case 'GET_USER_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'GET_NOTIFICATIONS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                apiData: { ...state.apiData, notifications: action.payload }
            }
        case 'GET_NOTIFICATIONS_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'GET_ADVICES_SUCCESS':
            return {
                ...state,
                isLoading: false,
                apiData: { ...state.apiData, advices: action.payload }
            }
        case 'GET_ADVICES_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'GET_LOCKED_ACHIEVS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                apiData: { ...state.apiData, lockedAchievs: action.payload }
            }
        case 'GET_LOCKED_ACHIEVS_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'UPDATE_COUNTRY_SUCCESS':
            toast.success(action.payload ? 'País adicionado à lista de favoritos com sucesso!' : 'País removido da lista de favoritos com sucesso!')

            return {
                ...state,
                isLoading: false,
            }
        case 'UPDATE_COUNTRY_ERROR':
            toast.error('Infelizmente ocorreu um erro e não foi possível adicionar este país à sua lista de grupos')

            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'UPDATE_MATILDE_AVATAR_SUCCESS':
            toast.success('Avatar alterado com sucesso!')
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'UPDATE_MATILDE_AVATAR_ERROR':
            toast.error('Infelizmente aconteceu um erro e não foi possível atualizar o seu avatar')

            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'SET_ADVICE_SUCCESS':
            toast.success('Conselho submetido com sucesso!')
            return {
                ...state,
                isLoading: false,
            }
        case 'SET_ADVICE_ERROR':
            let errAdvice = action.error?.length ? action.error.length : action.error?.character ? action.error.character : null
            toast.error(errAdvice ? errAdvice : 'Infelizmente ocorreu um erro e não foi possível submeter o conselho')

            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'SET_COMMENT_SUCCESS':
            toast.success('Comentário submetido com sucesso!')
            return {
                ...state,
                isLoading: false,
            }
        case 'SET_COMMENT_ERROR':
            let errComment = action.error?.length ? action.error.length : action.error?.character ? action.error.character : null
            toast.error(errComment ? errComment : 'Infelizmente ocorreu um erro e não foi possível submeter o comentário')

            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        case 'UPDATE_REACTION_SUCCESS':
            toast.success('Reação submetida com sucesso')

            return {
                ...state,
                updatingReactions: false
            }
        case 'UPDATE_REACTION_ERROR':
            toast.error('Infelizmente ocorreu um erro e não foi possível submeter a sua reação')
            return {
                ...state,
                updatingReactions: false
            }
        default:
            return state
    }
}

export default apiReducer;